import { ButtonAppearance, ButtonShape, ButtonSize } from "@fluentui/web-components";
/**
 * Menu Button Appearance constants
 * @public
 */
export const MenuButtonAppearances = ButtonAppearance;
/**
 * A Menu Button can be square, circular or rounded.
 * @public
 */
export const MenuButtonShapes = ButtonShape;
/**
 * A Menu Button can be a size of small, medium or large.
 * @public
 */
export const MenuButtonSizes = ButtonSize;
//# sourceMappingURL=menu-button.options.js.map